/* eslint-disable no-param-reassign */
import { action, computed, thunk } from 'easy-peasy';
import {
  size,
  keyBy,
  flow,
  get,
  reduce,
  includes,
  reject,
  set,
  has
} from 'lodash/fp';
import { fetchProgramAvailableOutreaches } from '../../services/fbm-api';
import {
  PENDING,
  ACTIVE,
  COMPLETED,
  CONFIRMED,
  ON_HOLD
} from '../../constants/ReservationStatus';

export default {
  data: null,
  meta: null,
  loading: false,
  fetch: thunk(async (actions, payload, { getStoreActions }) => {
    try {
      actions.setLoading(true);
      const response = await fetchProgramAvailableOutreaches(payload);
      actions.set(response);
    } catch ({ message }) {
      getStoreActions().notifications.showError({ message });
    } finally {
      actions.setLoading(false);
    }
  }),
  set: action((state, payload) => {
    const { items, meta } = payload;
    state.data = { ...(state.data || {}), ...keyBy('id', items) };
    state.meta = { ...meta, count: size(items) };
  }),
  clear: action(state => {
    state.data = null;
    state.meta = null;
  }),
  setLoading: action((state, loading) => {
    state.loading = loading;
  }),
  noReservationOutreaches: computed(
    [get('data'), (_, storeState) => get('userReservations.data', storeState)],
    (outreaches, userReservations) => {
      const validStatus = [PENDING, ACTIVE, COMPLETED, CONFIRMED, ON_HOLD];
      const outreachesWithReservation = reduce(
        (all, { status, meta: { outreachId } }) =>
          includes(status, validStatus)
            ? set(outreachId, outreachId, all)
            : all,
        {},
        userReservations
      );

      return reject(({ id }) => has(id, outreachesWithReservation), outreaches);
    }
  ),
  getMatchedAndEligibleProgramIdsForOutreach: computed(
    ({ data }) => outreachId =>
      flow(
        get(`${outreachId}.trackingMethods`),
        reduce(
          (all, { id, isMatch, isGuestEligible }) =>
            isMatch && isGuestEligible ? [...all, id] : all,
          []
        )
      )(data)
  )
};
